import { useEffect } from "react";

function upsertMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url) {
  if (!url) return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

export default function useSeo({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
  ogUrl,
  ogType = "website",
}) {
  useEffect(() => {
    if (title) document.title = title;

    upsertMeta("description", description);

    // OpenGraph (partages)
    upsertProperty("og:title", ogTitle || title);
    upsertProperty("og:description", ogDescription || description);
    upsertProperty("og:url", ogUrl || canonical);
    upsertProperty("og:type", ogType);

    // Canonical
    setCanonical(canonical);
  }, [title, description, canonical, ogTitle, ogDescription, ogUrl, ogType]);
}
